//initialize tokbox
export const INITIALIZA_TOKBOX = "INITIALIZA_TOKBOX";